import { Component, Inject } from '@angular/core';
import {
  IGetListaPerfilDto,
  IPerfilResponse,
  IUsarioPerfilDto,
} from '../model/interfaces-perfil';
import { PerfisService } from '../perfis.service';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { UsuarioDtoResponse } from '../model/UsuarioDtoResponse';
import { IUsuarioArmazenamentoLocal } from '../model/usuario-sso-model';

@Component({
  selector: 'app-listar-perfis',
  templateUrl: './listar-perfis.component.html',
  styleUrls: ['./listar-perfis.component.scss'],
})
export class ListarPerfisComponent {
  usuario!: IUsuarioArmazenamentoLocal;

  lstperfis: Array<IPerfilResponse> = [];
  perfil?: IPerfilResponse;
  usuariosDaEntidade: UsuarioDtoResponse[] = [];

  mensagens: string[] | [] = [];
  statusSucesso: string | 'alert-success' = 'alert-success';
  listaUsuariosDoPerfil!: Array<IUsarioPerfilDto>;
  loading: boolean = false;
  public paginaAtual = 1;

  constructor(
    private service: PerfisService,
    @Inject(Router) private router: Router
  ) {
    this.getDadosUsuario();
  }

  getUsuariosDaEntidade(): void {
    this.loading = true;
    this.service
      .getListUsuariosPorEntidade(this.usuario.guid)
      .subscribe((r) => {
        if (r.sucesso) {
          this.usuariosDaEntidade = r.retorno || [];
          this.loading = false;
        } else {
          this.mensagens = r.mensagens;
          this.statusSucesso = 'alert-danger';
          this.loading = false;
        }
      });
  }

  getDadosUsuario(): void {
    this.service.getUsuarioLocalStorage().subscribe((r) => {
      if (r != null) {
        this.usuario = r;
        this.buscarPerfis();
        this.getUsuariosDaEntidade();
      } else {
        this.router.navigateByUrl('login');
      }
    });
  }

  exportTableToExcel(tableId: string, fileName: string): void {
    const table = document.getElementById(tableId);

    if (table) {
      const workSheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
      const workBook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, tableId);
      XLSX.writeFile(workBook, `${fileName}.xlsx`);
    }
  }

  exportUsuariosToExcel(tableId: string, fileName: string): void {
    if (this.listaUsuariosDoPerfil.length > 0) {
      const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        this.usuariosDaEntidade
      );
      const workBook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, tableId);
      XLSX.writeFile(workBook, `${fileName}.xlsx`);
    }
  }

  mostrarEditarPerfil(perfil: IPerfilResponse, modoVisao: boolean): void {
    this.router.navigateByUrl(`perfis/mostrar-editar-perfil`, {
      state: { perfil: perfil, modoVisao: modoVisao },
    });
  }

  gerenciarUsuariosDoPerfil(): void {
    this.router.navigateByUrl(`perfis/gerenciar-usuarios`, {
      state: {
        usuariosDaEntidade: this.usuariosDaEntidade,
        lstperfis: this.lstperfis,
      },
    });
    
  }

  buscarPerfis(): void {
    this.loading = true;
    var dto: IGetListaPerfilDto = {
      codEntidade: this.usuario.codigoEntidade,
    };

    this.service.getListaPerfisCriados(this.usuario.guid).subscribe((r) => {
      if (r.sucesso) {
        this.lstperfis =
          r.retorno == null
            ? []
            : r.retorno.perfil.sort((a, b) => a.codperfil - b.codperfil);
        this.loading = false;
      } else {
        this.mensagens = r.mensagens;
        this.statusSucesso = 'alert-danger';
        this.loading = false;
        if (r.mensagens.includes('Usuário inválido!')) {
          console.log('Usuário inválido!');
          this.router.navigateByUrl('login');
        }
      }
    });
  }
}
